
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { isActiveSubscriber } from "@/utils/authDestination";

type ProtectedRouteProps = {
  children: React.ReactNode;
  redirectTo?: string;
  requireAdmin?: boolean;
};

const ProtectedRoute = ({
  children,
  redirectTo = "/login",
  requireAdmin = false,
}: ProtectedRouteProps) => {
  const { isAuthenticated, isLoading, profileLoaded, user } = useAuth();

  console.log("🔒 ProtectedRoute VERIFICAÇÃO:", {
    isLoading,
    isAuthenticated,
    profileLoaded,
    userPlan: user?.plan,
    isSubscribed: user?.isSubscribed,
    userRole: user?.role,
    requireAdmin,
  });

  // Spinner enquanto auth inicializa OU enquanto o profile do usuário logado não carregou.
  // Evita rebote para /planos no estado mínimo (plan: null) imediatamente após login.
  if (isLoading || (isAuthenticated && !profileLoaded)) {
    console.log("⏳ Carregando autenticação/profile...");
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Não autenticado → login
  if (!isAuthenticated) {
    console.log("❌ Usuário NÃO autenticado, redirecionando para login");
    return <Navigate to={redirectTo} replace />;
  }

  // Admin obrigatório
  if (requireAdmin && user?.role !== "admin") {
    console.log("⛔ Acesso de ADMIN necessário, redirecionando para home");
    return <Navigate to="/" replace />;
  }

  // BLOQUEIO: usa MESMA fonte de verdade do LoginPage (isActiveSubscriber)
  if (!isActiveSubscriber(user)) {
    console.log("🚫 Sem assinatura ativa — redirecionando para /planos", {
      plan: user?.plan,
      isSubscribed: user?.isSubscribed,
      role: user?.role,
    });
    return <Navigate to="/planos" replace />;
  }

  console.log("✅ Acesso LIBERADO");
  return <>{children}</>;
};

export default ProtectedRoute;
